import React from 'react';
import DocumentTabs from './DocumentTabs';
import DocumentEditor from './DocumentEditor';
import SurveyEditor from '../survey/SurveyEditor';
import useDocumentManager from '../../hooks/useDocumentManager';

/**
 * Main document workspace component
 * Combines document tabs and editor in a side-by-side layout
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Optional custom editor component
 * @returns {JSX.Element} - Rendered component
 */
function DocumentWorkspace({ children }) {
  const { activeDocument } = useDocumentManager();
  
  const renderEditor = () => {
    // If children are provided, render them instead
    if (children) {
      return children;
    }
    
    // If the active document is a survey, render the SurveyEditor
    if (activeDocument?.type === 'survey') {
      return <SurveyEditor />;
    }
    
    // Otherwise render the regular DocumentEditor
    return <DocumentEditor />;
  };
  return (
    <div style={{ 
      display: 'flex', 
      height: 'calc(100vh - 100px)', // Adjust based on your app header/nav
      overflow: 'hidden',
      margin: '20px 0'
    }}>
      <DocumentTabs />
      <div style={{ flex: 1, paddingLeft: '20px' }}>
        {renderEditor()}
      </div>
    </div>
  );
}

export default DocumentWorkspace;
